import React from 'react';
import { MDBCard, MDBRow, MDBCol, MDBCardText, MDBCardHeader, MDBCardFooter, MDBBtn, MDBContainer } from
    "mdbreact";
import ScrollBarNav  from './ScrollBarNav';
import SubscribePage from './subscribe';
import {Hamburger} from './hamburger';

const Menu = () => {
    return (
        <>
            <MDBRow>
                <MDBCol>

                    

                    <MDBContainer id="menu" style={{position: "fixed", zIndex: "3" }}>

                    

                        <MDBCard id="mcard" style={{ width: "25rem", height: "100%", position: "fixed", backgroundColor: "rgba(0,0,0,0.5)", color: "white", zIndex: "3", right: "0"}}>
                            
                            <MDBContainer style={{visibility: "visible"}}>

                            <Hamburger style={{position: "fixed", zIndex: "99" }} />
                            
                            </MDBContainer>

                            <h2 className="menutext" style={{top: "5%", position: "relative", textAlign: "center", borderBottom: "1px solid white", borderBottomColor: "white", paddingBottom: "5px" }}>Menu</h2>

                <div style={{position: "relative", width: "100%", textAlign: "left"}}>
                <ScrollBarNav />
                </div>
                    <div className= "subpage" id="subpage" style={{position: "absolute", width: "100%", marginTop: "95%"}}>
                        <SubscribePage style={{ background: "transparent", width: "100%", position: "absolute"}}></SubscribePage>
                        </div>
                </MDBCard>

                    </MDBContainer>
                    
                </MDBCol>
           </MDBRow>

        
        </>
    );
}

export { Menu }
